export function filterSpaces(string = "", regex = /\s{1,}/) {
  return string
    .trimStart()
    .split(regex)
    .filter((s) => s !== "")
    .join(" ");
}

export * from "./regexps";
